import {  fetchWrapper } from '@/_helpers';

export const conferenceApi = {
    guestJoin: (conferenceId, data) => fetchWrapper.post(`conference/${conferenceId}/guest/join`, data),
    guestRequest: (conferenceId) => fetchWrapper.post(`conference/${conferenceId}/guest/request`),
    guestApprove: (conferenceId, data) => fetchWrapper.post(`conference/${conferenceId}/guest/approve`, data),
    startRecording: (conferenceId) =>
        fetchWrapper.post(`conference/${conferenceId}/recording`, {
            action: 'start',
        }),
    stopRecording: (conferenceId) =>
        fetchWrapper.post(`conference/${conferenceId}/recording`, {
            action: 'stop',
        }),

    updateConference: (conferenceId, data) => fetchWrapper.put(`conference/${conferenceId}/update`, data),
};
